import './authHelpers';
import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_BASE || 'http://localhost:8000/api';
const API_URL = `${API_BASE}/financiero`;

// Configurar axios para incluir el token de autenticación
axios.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('authToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Asignaciones de Becas a Estudiantes - CRUD
export const getStudentScholarships = async (params = {}) => {
  const { estudiante, estado, search, ordering, page, page_size } = params;
  let url = `${API_URL}/estudiantes-becas/`;
  const query = [];
  if (estudiante) query.push(`estudiante=${encodeURIComponent(estudiante)}`);
  if (estado) query.push(`estado=${encodeURIComponent(estado)}`);
  if (search) query.push(`search=${encodeURIComponent(search)}`);
  if (ordering) query.push(`ordering=${encodeURIComponent(ordering)}`);
  if (page) query.push(`page=${page}`);
  if (page_size) query.push(`page_size=${page_size}`);
  if (query.length) url += `?${query.join('&')}`;
  const res = await axios.get(url);
  return res.data;
};

export const getStudentScholarship = async (id) => {
  const res = await axios.get(`${API_URL}/estudiantes-becas/${id}/`);
  return res.data;
};

export const createStudentScholarship = async (data) => {
  const res = await axios.post(`${API_URL}/estudiantes-becas/`, data);
  return res.data;
};

export const updateStudentScholarship = async (id, data) => {
  const res = await axios.patch(`${API_URL}/estudiantes-becas/${id}/`, data);
  return res.data;
};

export const deleteStudentScholarship = async (id) => {
  const res = await axios.delete(`${API_URL}/estudiantes-becas/${id}/`);
  return res.data;
};
